import React, { useMemo } from "react";
import { useAppSelector } from "../../hooks";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { TBToCMessage } from "../../types/types";
import "./index.css";
import { getSecrets } from "../../config";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { removeWWWPrefix } from "../../utils/format.utils";

type Prop = {
  message?: TBToCMessage;
  toDomain: string;
};
const ChatListItem = ({ message, toDomain }: Prop) => {
  const { LOGO_BASE_URL } = getSecrets();
  const { logoUrl, roomDomain } = useWhiteboardRoom();
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { push } = useRouter();
  const targetDomain = useMemo(() => {
    if (!message) return toDomain;
    if (message.messageType === "c_to_b") return message.toDomain;
    return message.toDomain;
  }, [currentAddress, message]);
  const { secondFontColor } = useAppSelector((state) => state.layout);

  const msgTime = () => {
    if (!message) return "";
    const today = new Date();
    const messageTime = new Date(message.createdAt);
    if (
      today.toDateString().slice(-4) === messageTime.toDateString().slice(-4)
    ) {
      if (today.toDateString() === messageTime.toDateString()) {
        // For the today messages, we only display the time
        return messageTime.toTimeString().slice(0, 5);
      }
      // For the messages sent in the current year, we only display the date without year info
      return messageTime.toLocaleString("en-GB").slice(0, 5);
    }
    return messageTime.toLocaleString("en-GB").slice(3, 10);
  };

  const getText = () => {
    if (!message) return "";
    return message.messageText;
  };

  const parse_url_first_letter = (url: string) => {
    if (url.includes("https://")) {
      return url.split("https://")[1][0].toUpperCase();
    } else if (url.includes("http://")) {
      return url.split("http://")[1][0].toUpperCase();
    } else {
      return url[0].toUpperCase();
    }
  };

  return (
    <li className={`${toDomain === targetDomain && "active"}`}>
      <div
        className="dm-item"
        onClick={(e) => {
          push({
            pathname: ROUTES.B_TO_C_PAGE + `/${targetDomain}`,
          });
        }}
      >
        <div aria-hidden="true" className="d2c-brand-logo">
          { (roomDomain == targetDomain && logoUrl) ? (
            <img
              className="d2c-logo-image"
              src={
                logoUrl
              }
            />
          ) : ( message?.logoUrl && message?.logoUrl.includes(LOGO_BASE_URL)) ? (
            <img
              className="d2c-logo-image"
              src={
                message.logoUrl
              }
            />
          ) : message?.logoUrl != "" && message?.logoUrl != null ? (
            <img
              className="d2c-logo-image"
              src={
                LOGO_BASE_URL +
                removeWWWPrefix(targetDomain) +
                "/" +
                message.logoUrl
              }
            />
          ) : (
            parse_url_first_letter(targetDomain)
          )}
        </div>
        <div className="d2c-item-description-container">
          <div className="d2c-item-user-name-block">
            <div className="d2c-item-user-name">{targetDomain}</div>
          </div>
          <div
            className="d2c-item-user-name"
            style={{ color: secondFontColor }}
          >
            {getText()}
          </div>
          {message?.message_count > 0 && (
            <div
              style={{
                opacity: "1",
              }}
            >
              <div className="unread-list-dot">{message.message_count}</div>
            </div>
          )}
        </div>
        <div className="list-item-time" style={{ color: secondFontColor }}>
          {msgTime()}
        </div>
      </div>
    </li>
  );
};
export default ChatListItem;
